import { useNavigate } from "react-router-dom";
import { Settings, UserCog, ChevronDown, X } from "lucide-react";
import { Header } from "@/components/Header";

const SettingsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="app-container" data-testid="settings-page">
      <Header />

      {/* Settings Content */}
      <main className="main-content">
        <div className="device-page-header">
          <div>
            <h1 className="device-page-title settings-title">
              <Settings size={24} className="settings-icon" />
              Settings
            </h1>
            <p className="device-page-subtitle">Manage system configuration</p>
          </div>
          <button className="close-btn" onClick={() => navigate('/')} data-testid="close-btn">
            <X size={24} />
          </button>
        </div>

        <div className="settings-menu" data-testid="settings-menu">
          <button 
            className="settings-menu-item" 
            onClick={() => navigate('/settings/field-techs')}
            data-testid="field-techs-menu-item"
          >
            <UserCog size={24} className="settings-menu-icon" />
            <div className="settings-menu-text">
              <span className="settings-menu-title">Field Techs</span>
              <span className="settings-menu-description">Manage field technicians and their assignments</span>
            </div>
            <ChevronDown size={20} className="settings-menu-arrow" style={{ transform: 'rotate(-90deg)' }} />
          </button>
        </div>
      </main>
    </div>
  );
};

export default SettingsPage;
